import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { thunk } from 'redux-thunk';
import { createEpicMiddleware } from 'redux-observable';
import epics from './epic';
import asyncMiddleware from '../middleware/asyncMiddleware';

import * as Counter from './Counter';
import * as WeatherForecasts from './WeatherForecasts';
import globalReducer from '../reducers/globalReducer';
import solarstep1Reducer from '../reducers/solarstep1';
import leistungReducer from '../reducers/leistung';
import powerMaxConsumptionDailyReducer from '../reducers/powerMaxConsumptionDaily';
import vorhersageReducer from '../reducers/vorhersage';
import istReducer from '../reducers/ist';
import istAllYearsReducer from '../reducers/istAllYears';
import durchschnittReducer from '../reducers/durchschnitt';
import wechselrichterReducer from '../reducers/wechselrichter';
import yearStromGesamtReducer from '../reducers/yearStromGesamt';
import evupvReducer from '../reducers/evu_pv';
import verbrauchReducer from '../reducers/verbrauch';
import evubillReducer from '../reducers/evuBill';
import pvbillReducer from '../reducers/pvBill';
import abschlagReducer from '../reducers/abschlag';
import pvfinalbillReducer from '../reducers/pvFinalBill';
import einnahmenReducer from '../reducers/einnahmen';
import stromReducer from '../reducers/strom';
import clientConfigurationReducer from '../reducers/clientConfiguration';
import finanzUebersichtReducer from '../reducers/finanzUebersicht';
import wattAmTagBellCurveReducer from '../reducers/wattAmTagBellCurve';
import pvJahresvergleichReducer from '../reducers/pvJahresvergleich';
import bezugAnalyseReducer from '../reducers/bezugAnalyse';

export default function configureStore(initialState) {
    const reducers = {
        globalReducer,
        counter: Counter.reducer,
        weatherForecasts: WeatherForecasts.reducer,
        solarstep1Reducer,
        leistungReducer,
        vorhersageReducer,
        istReducer,
        istAllYearsReducer,
        durchschnittReducer,
        wechselrichterReducer,
        yearStromGesamtReducer,
        evupvReducer,
        verbrauchReducer,
        evubillReducer,
        pvbillReducer,
        abschlagReducer,
        pvfinalbillReducer,
        einnahmenReducer,
        stromReducer,
        clientConfigurationReducer,
        finanzUebersichtReducer,
        powerMaxConsumptionDailyReducer,
        wattAmTagBellCurveReducer,
        pvJahresvergleichReducer,
        bezugAnalyseReducer
    };

    const epicMiddleware = createEpicMiddleware();
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

    const middleware = [thunk];

    // In development, use the browser's Redux dev tools extension if installed
    const enhancers = [];
    const isDevelopment = process.env.NODE_ENV === 'development';
    if (isDevelopment && typeof window !== 'undefined' && window.devToolsExtension) {
        enhancers.push(window.devToolsExtension());
    }

    const rootReducer = combineReducers({
        ...reducers
    });

    const store = createStore(
        rootReducer,
        initialState,
        composeEnhancers(
            applyMiddleware(...middleware, epicMiddleware, asyncMiddleware),
            ...enhancers
        )
    );

    epicMiddleware.run(epics);

    return store;
}